import type { IVariable, ImageVariable } from '@carboncopyco/types';
import { useCallback, useMemo } from 'react';
import { object } from 'yup';
import {
  getVariableDescriptionSchema,
  getVariableNameSchema,
} from '../schemas';

interface FormSchemaOptions {
  variable?: ImageVariable;
  variables?: IVariable[];
}

export const useFormSchema = ({
  variable,
  variables = [],
}: FormSchemaOptions) => {
  const getExistingValues = useCallback(
    (key: keyof ImageVariable) =>
      variables
        .filter((vari) => vari[key] !== variable?.[key])
        .map((vari) => vari[key]),
    [variable, variables]
  );

  const existingNames = useMemo(
    () => getExistingValues('name'),
    [getExistingValues]
  );

  return useMemo(() => {
    return object({
      name: getVariableNameSchema({ existingNames }),
      description: getVariableDescriptionSchema(),
    });
  }, [existingNames]);
};
